import React, { useRef } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import OwlCarousel from 'react-owl-carousel2';
import SectionTitle from '../../../commons/sectionTitle/SectionTitle';
import BlockResidenceComponent from '../../../commons/block/BlockResidence.component';
import { ARROW_LEFT, ARROW_RIGHT } from '../../../../utils/constants';

const Properties = props => {
  let listItems = props.data && props.data.items && props.data.items.length ? props.data.items : null;

  const options = {
    items: 3,
    margin: 30,
    nav: true,
    dots: false,
    loop: false,
    navText: [ARROW_LEFT, ARROW_RIGHT],
    responsive: {
      0: { items: 1, nav: true },
      600: { items: 3, nav: true },
      1000: { items: 3, nav: true },
    },
  };
  const Properties = useRef(null);

  return (
    <div className="section-block  hidden-print">
      <div className={(props.class || '') + ' container'}>
        <SectionTitle title={props.headerTitle || ''} />
        <Row>
          <Col xs={12}>
            {listItems && listItems.length ? (
              <OwlCarousel
                ref={Properties}
                options={options}
                className="nav-top owl-carousel owl-theme owl-loaded owl-drag"
              >
                {listItems.map((element, index) => {
                  if (!element) return null;
                  return (
                    <div key={index} className="col-item">
                      <BlockResidenceComponent section="RESIDENCES_LIKE" post={element} />
                    </div>
                  );
                })}
              </OwlCarousel>
            ) : (
              ''
            )}
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default Properties;
